<template>
    <div class="w-10/12 m-auto">
        <div>
            <g v-html="image" v-if="!loading"></g>
        </div>
        <div v-if="loading" class="text-center">
            <loader></loader>
        </div>
    </div>

</template>

<script>
import {qrCodeFormStore} from "@/scripts/store/qr_code_form.store";
import {mapState} from "pinia";
import VDropDown from "@/scripts/components/app/common/VDropDown.vue";

export default {
    components: {VDropDown},
    data() {
        return {
            image: null,
            style: {},
            loading: false,
            items: [],
            abortController: null
        }
    },
    computed: {
        ...mapState(qrCodeFormStore, ['code'])
    },
    mounted() {
        this.style = JSON.parse(JSON.stringify(this.code.style))
        this.abortController = new AbortController();
        this.updateImage(this.code.style)

        qrCodeFormStore().$subscribe((mutation, state) => {
            if (JSON.stringify(this.style) === JSON.stringify(state.code.style)) {
                return
            }

            this.style = JSON.parse(JSON.stringify(state.code.style))

            this.updateImage(state.code.style)
        })
    },
    methods: {
        resetRequest() {
            this.abortController.abort();
            this.abortController = new AbortController();
        },

        updateImage(style) {
            this.loading = true

            const path = this.code.identifier
                ? `/api/qrcode/image?identifier=${this.code.identifier}`
                : '/api/qrcode/image'

            this.resetRequest()
            axios.post(
                path,
                {style: style},
                {signal: this.abortController.signal}
            )
                .then(response => {
                    this.image = response.data
                })
                .finally(() => {
                    this.loading = false
                })
        },
    }
}
</script>

<style scoped>

</style>
